import http from 'hub-http/clients/apiClient';
export function fetchHubScopes(portalId) {
  return http.get(`hubs2/v1/scopes/hub/${portalId}`);
}